export default __webpack_public_path__ + "static/media/chat-1.b09b1257.PNG";